import { FavoriteFillIcon, FavoriteIcon } from '@docnboard/icons/rc';
import { cssVar } from '@docnboard/theme';
import type { SVGProps } from 'react';

export const IsFavoriteIcon = ({
  favorite,
  style,
  ...props
}: { favorite?: boolean } & SVGProps<SVGSVGElement>) => {
  return favorite ? (
    <FavoriteFillIcon
      style={{ color: cssVar('primaryColor'), ...style }}
      {...props}
    />
  ) : (
    <FavoriteIcon style={style} {...props} />
  );
};
